import { TOURIST_SOURCE_MAP_VISUALIZERS_SET_SHOWN_STATE, TOURIST_SOURCE_SET_CURRENT_SELECTION } from'../actions/actionTypes';

import cloneDeep from 'lodash/cloneDeep';

const newMapVisualizerState = (oldState) => {
    if(oldState) return cloneDeep(oldState)

    return {
        mapVisualizerIndex: -1,
        shownRegion: null,
        shownDataType: null,
        shownSource: null
    }
}

const initialState = {
    currentSelection: {
        region: null,
        dataType: null,
        source: null
    },
    mapVisualizerStates: []
};

function reducer(state = initialState, action) {
    let nextState = cloneDeep(state);

    switch (action.type) {
        case TOURIST_SOURCE_MAP_VISUALIZERS_SET_SHOWN_STATE: {
            const { mapVisualizerIndex, shownRegion, shownDataType, shownSource } = action
            const oldMapVisualizerState = nextState.mapVisualizerStates[mapVisualizerIndex]
            const mapVisualizerState = newMapVisualizerState(oldMapVisualizerState)

            mapVisualizerState.mapVisualizerIndex = mapVisualizerIndex
            if(shownRegion) mapVisualizerState.shownRegion = shownRegion
            if(shownDataType) mapVisualizerState.shownDataType = shownDataType
            if(shownSource) mapVisualizerState.shownSource = shownSource
            nextState.mapVisualizerStates[mapVisualizerIndex] = mapVisualizerState
            return nextState;
        }
        case TOURIST_SOURCE_SET_CURRENT_SELECTION: {
            const { region, dataType, source } = action
            nextState.currentSelection = { region, dataType, source }
            return nextState
        }
        default: {
            return state;
        }
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/reducers/touristSourceState.js